module.exports = __webpack_public_path__ + "static/media/icn-chevron-down.5b433eca.svg";